
export enum ContactTypeEnum {
    SITE = "SITE",
    ANNOUNCEMENT = "ANNOUNCEMENT",
    INFLUENCER = "INFLUENCER",    
    INSTAGRAM = "INSTAGRAM",    
}